import { jsx as _jsx } from "react/jsx-runtime";
export const BimEmpty = _jsx("div", { children: "\u52A0\u8F7D BimFace Sdk \u4E2D\uFF0C\u8BF7\u7A0D\u7B49" });
